import { render, staticRenderFns } from "./addField.vue?vue&type=template&id=56bd7161"
import script from "./addField.vue?vue&type=script&lang=js"
export * from "./addField.vue?vue&type=script&lang=js"
import style0 from "./addField.vue?vue&type=style&index=0&id=56bd7161&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports